import { graphql } from "~/gql";

export const DELETE_ALL_NOTIFICATIONS = graphql(/* GraphQL */ `
  mutation DeleteAllNotifications {
    deleteAllNotifications {
      success
    }
  }
`);
